<script setup lang="ts">
withDefaults(defineProps<{ size?: number | string; color?: string }>(), {
  size: 24,
  color: "currentColor",
});
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    :width="size"
    :height="size"
    :fill="color"
    v-bind="$attrs"
  >
    <path
      d="M12 3.09998C12.4971 3.09998 12.9 3.50292 12.9 3.99998V13.4164L15.3337 10.7363C15.6679 10.3684 16.2371 10.3409 16.605 10.6751C16.973 11.0093 17.0004 11.5784 16.6663 11.9464L12.6663 16.3513C12.4957 16.5391 12.2537 16.6462 12 16.6462C11.7463 16.6462 11.5043 16.5391 11.3337 16.3513L7.33373 11.9464C6.99957 11.5784 7.02699 11.0093 7.39497 10.6751C7.76294 10.3409 8.33213 10.3684 8.66628 10.7363L11.1 13.4164V3.99998C11.1 3.50292 11.5029 3.09998 12 3.09998Z"
    />
    <path
      d="M5.10001 20C5.10001 19.5029 5.50295 19.1 6.00001 19.1H18C18.4971 19.1 18.9 19.5029 18.9 20C18.9 20.497 18.4971 20.9 18 20.9L6.00001 20.9C5.50295 20.9 5.10001 20.497 5.10001 20Z"
    />
  </svg>
</template>
